import { Link } from 'react-router-dom';


import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AuthWrapper from 'sections/auth/AuthWrapper';
import FirebaseRegister from 'sections/auth/AuthRegister';



export default function Register() {
  return (
    <AuthWrapper>
      <Grid container spacing={3}>
        <Grid size={{xs:12}}>
          <Stack direction="column" sx={{ alignItems: 'center', justifyContent: 'center', mb: 2, textAlign: 'center' }}>
            <Typography variant="h3">Sign up</Typography>
            <Typography component={Link} to="/login" variant="body1" sx={{ textDecoration: 'none', mt: 1 }} color="primary">
              Already have an account?
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{xs:12}}>
          <FirebaseRegister />
        </Grid>
      </Grid>
    </AuthWrapper>
  );
}
